import { EMediaModule } from 'app/core/enums/media-type.enum';

export const IMAGE_REGEXP = new RegExp(/\.(bmp|jpg|jpeg|png|gif|svg|webp|heic|avif|heif)$/);
export const VIDEO_REGEXP = new RegExp(/\.(3g2|3gp|avi|flv|ts|m2ts|mts|mov|mkv|mp4|mpeg|mxf|ogv|webm|wmv|quicktime)$/);
export const AUDIO_REGEXP = new RegExp(/\.(ogg|oga|aac|aiff|amr|flac|m4a|mp3|opus|wav)$/);

export const MEDIA_BILLING_MODULES: EMediaModule[] = [EMediaModule.ORDER, EMediaModule.FINANCIAL, EMediaModule.EMPLOYEE];
